export default {
  LOGS: "लॉग्स",
};
